import { JobDescriptionDocument } from '../jobDescriptionDocument';


export class JobDescriptionDocumentSerializer {
    fromJson(json: any): JobDescriptionDocument {
        const data = new JobDescriptionDocument();
        data.jobDescription = json.jobDescription;
        data.file = json.file;
        return data;
    }

    toJson(data: JobDescriptionDocument): any {
        return {
            id: data.id,
            jobDescription: data.jobDescription,
            file: data.file
        };
    }
}